var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.75024H10M4.75 10.0002V13.0002M15.25 7.00024V10.0002M10 15.2502H13M15.25 17.5002V17.5002C16.4926 17.5002 17.5 16.4929 17.5 15.2502V15.2502C17.5 14.0076 16.4926 13.0002 15.25 13.0002V13.0002C14.0074 13.0002 13 14.0076 13 15.2502V15.2502C13 16.4929 14.0074 17.5002 15.25 17.5002ZM4.75 17.5002V17.5002C5.99264 17.5002 7 16.4929 7 15.2502V15.2502C7 14.0076 5.99264 13.0002 4.75 13.0002V13.0002C3.50736 13.0002 2.5 14.0076 2.5 15.2502V15.2502C2.5 16.4929 3.50736 17.5002 4.75 17.5002ZM15.25 7.00024V7.00024C16.4926 7.00024 17.5 5.99288 17.5 4.75024V4.75024C17.5 3.5076 16.4926 2.50024 15.25 2.50024V2.50024C14.0074 2.50024 13 3.5076 13 4.75024V4.75024C13 5.99288 14.0074 7.00024 15.25 7.00024ZM4.75 7.00024V7.00024C5.99264 7.00024 7 5.99288 7 4.75024V4.75024C7 3.5076 5.99264 2.50024 4.75 2.50024V2.50024C3.50736 2.50024 2.5 3.5076 2.5 4.75024V4.75024C2.5 5.99288 3.50736 7.00024 4.75 7.00024Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.4feca7afb9b4170497278b42d819d057.svg";
export { ForwardRef as ReactComponent };